import { setStatic } from './setStatic';
export var setDisplayName = function (displayName) {
    return setStatic('displayName', displayName);
};
